<template>
  <BaseModal
    :modal-id="modalId"
    title="Platební detaily"
    :show-footer="false"
    :css-classes="['modal-sm']"
  >
    <p class="fs-4 my-3">
      Platbu můžete jednoduše uhradit pomocí bankovního převodu nebo využijte QR kód.
    </p>

    <div v-if="paymentData" class="payment-qr">
      <div v-html="paymentData.qr_svg"></div>
      <div class="d-block text-center">
        <p class="fs-5 fs-white mb-0">
          Oskenujte QR kód přes<br> aplikaci vaší banky
        </p>
      </div>
    </div>

    <h3>Údaje pro platbu převodem</h3>

    <div class="card mb-4">
      <div class="card-body">
        <div class="row item align-items-center g-0">
          <div class="col-12 col-md-5">
            <p class="fs-4">Variabilní symbol</p>
          </div>
          <div class="col-12 col-md-7">
            <p class="fs-4"><strong>{{ paymentData?.variable_symbol || '-' }}</strong></p>
          </div>
        </div>
        <div class="row item align-items-center g-0">
          <div class="col-12 col-md-5">
            <p class="fs-4">Číslo účtu</p>
          </div>
          <div class="col-12 col-md-7">
            <p class="fs-4"><strong>{{ paymentData?.account_number || '-' }}</strong></p>
          </div>
        </div>
        <div class="row item align-items-center g-0">
          <div class="col-12 col-md-5">
            <p class="fs-4">Částka</p>
          </div>
          <div class="col-12 col-md-7">
            <p class="fs-4"><strong>{{ formattedAmount }} Kč</strong></p>
          </div>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="modal-footer">
        <button type="button" class="btn btn-lg btn-outline-gray flex-fill ps-1 pe-1" @click="closeModal">
          Hotovo, uhrazeno
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from './BaseModal.vue';

export default {
  name: 'PaymentQrModal',
  components: {
    BaseModal
  },
  setup() {
    const store = useStore();
    const modalId = 'paymentQrModal';

    const paymentData = computed(() => {
      const params = store.getters['ModalStore/params'];
      return params?.paymentData || null;
    });

    const formattedAmount = computed(() => {
      if (!paymentData.value?.amount) return '0';
      return new Intl.NumberFormat('cs-CZ', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(paymentData.value.amount);
    });

    const closeModal = () => {
      store.dispatch('ModalStore/closeModal');
    };

    return {
      modalId,
      paymentData,
      formattedAmount,
      closeModal
    };
  }
};
</script>
